import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2zlerrpi5b: FaireBrandEntity = {
  token: "b_2zlerrpi5b",
  type: "brand",
  name: "Subtle Tea",
  avatarUrl:
    "https://cdn.faire.com/fastly/4c221ae33c3a0a4f64754651acbd4423b0d79691a6621da9270095e3ea87e552.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e75b24b94c7a863326f5a51dfab444b17cc8d1f2af6396f5d45f6e3bc8155167.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4c221ae33c3a0a4f64754651acbd4423b0d79691a6621da9270095e3ea87e552.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e75b24b94c7a863326f5a51dfab444b17cc8d1f2af6396f5d45f6e3bc8155167.jpeg",
  location: "Ronkonkoma, NY, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 42,
  isInsider: true,
  description:
    "Subtle Tea is an all organic craft brewed iced tea, where we think it's important to 'Taste Tea First\" ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.473Z",
    importedBy: "entity-db-cli",
  },
};
